import { Chip, styled } from '@mui/material';
import { lighten } from '@mui/material/styles';
import { getValuationStatusPaletteColor } from 'dashboard409a/utilities/getValuationStatusPaletteColor';

const getStatusColor = (status?: string) => getValuationStatusPaletteColor(status);

interface StatusChipProps {
  status?: string;
}

/** Text on pastel chips — same in light/dark so each estado keeps hue + legibility */
const STATUS_CHIP_TEXT = 'rgba(0, 0, 0, 0.87)';

const StyledStatusChip = styled(Chip)<StatusChipProps>(({ theme, status }) => {
  const base = getStatusColor(status) ?? '#e0e0e0';
  const isDark = theme.palette.mode === 'dark';
  // Dark: mismo sistema de color que light (pastel sólido), un poco más suave para menos fatiga
  const backgroundColor = isDark ? lighten(base, 0.07) : base;
  return {
    backgroundColor,
    color: STATUS_CHIP_TEXT,
    // Borde suave solo en dark: la pastilla se lee sobre fila oscura sin fundirse
    border: isDark ? '1px solid rgba(0, 0, 0, 0.12)' : 'none',
    borderRadius: '10px',
    padding: `0px ${theme.spacing(1.5)}`,
    fontSize: '13px',
    fontWeight: 500,
    height: 26,
    '& .MuiChip-label': {
      paddingLeft: theme.spacing(0.75),
      paddingRight: theme.spacing(0.75),
    },
  };
});

const StyledSpanEmptyStatus = styled('span')(({ theme }) => ({
  fontSize: '14px',
  color: theme.palette.mode === 'dark' ? theme.palette.text.secondary : theme.palette.common.black,
}));

export {
  StyledStatusChip,
  StyledSpanEmptyStatus,
};
